package one.healthium.settings.data

import one.healthium.locale.LocaleProvider
import one.healthium.settings.data.api.SettingsApiClient
import one.healthium.settings.domain.SettingsMenuModel
import one.healthium.settings.domain.SettingsMenuRepository

class AppSettingsMenuRepository(
    private val settingsApiClient: SettingsApiClient,
    private val localeProvider: LocaleProvider
) : SettingsMenuRepository {

    private val cache = mutableMapOf<String, List<SettingsMenuModel>>()

    override suspend fun getMenu(menuId: String): List<SettingsMenuModel> {
        val cachedValue = cache[menuId]

        if (cachedValue != null) return cachedValue

        val response = settingsApiClient.getMenu(menuId, localeProvider.getLocale())
        val models = response.map { SettingsMenuModel(it.title, it.url) }
        cache[menuId] = models
        return models
    }
}